import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './MercadoCapitais.scoped.scss';

class MercadoCapitais extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas a mercado de capitais se deram em três frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_mercado1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Originação</h5>
                <p>
                  Ao final de 2020, aguardávamos a audiência pública da CVM sobre a nova norma das ofertas públicas,
                  publicada no início de março 2021. A nova norma, que substituirá as Instruções 400 e 476 hoje
                  existentes, deverá trazer uma matriz de ofertas, que levará em conta o tipo de investidor e o tipo de
                  emissor para a divulgação do regime informacional, em linha com as discussões realizadas entre ANBIMA
                  e CVM.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_mercado2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Securitização</h5>
                <p>
                  Em outubro, enviamos resposta à audiência pública da CVM para criação de norma para as companhias
                  securitizadoras, visando oferecer mais segurança, transparência e informação para o mercado.
                </p>
                <p>
                  Também foi elaborado documento que será parte do Código de Ofertas, com as regras e os procedimentos
                  para a classificação de CRIs e CRAs, de acordo com os lastros e riscos envolvidos. As novas normas,
                  submetidas à audiência pública em dezembro, têm por objetivo ampliar a transparência sobre as
                  operações ao investidor.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_mercado3} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Facilitação da participação de investidores</h5>
                <p>
                  Em função da publicação da norma que permite a participação e a votação a distância em assembleias de
                  debêntures, CRIs, CRAs e notas promissórias, definimos proposta de padronização das regras para a
                  convocação das assembleias pelos agentes fiduciários. As medidas foram incorporadas ao Código de
                  Ofertas e submetidas à audiência pública em dezembro.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div> */}
      </div>
    );
  }
}
export { MercadoCapitais };
